import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { fadeInAnimation } from '../../../../animations';
import * as fromRoot from '../../../../core/store';
import { EpsUserCreateAction } from '../../../../core/store/admin/users/users.actions';
import { EpsUser } from '../../../../core/store/admin/users/users.interface';
import { EpsUserEditContainer } from './eps-user-edit.container';
import { ScrollService } from '../../../../core/services/scroll.service';

@Component({
  selector: 'admin-customer-eps-create',
  templateUrl: './eps-user-edit.container.html',
  styleUrls: ['./eps-user-edit.container.scss'],
  animations: [fadeInAnimation],
})
export class EpsUserCreateContainer extends EpsUserEditContainer implements OnInit {
  readonly = false;

  constructor(route: ActivatedRoute, dialog: MatDialog, scrollService: ScrollService) {
    super(route, dialog, scrollService);
  }

  createUser(epsUser: EpsUser) {
    this.store.dispatch(new EpsUserCreateAction(epsUser));
  }
}
